export default "__VITE_ASSET__COmoUFIB__"